export const PreOrderStatusEnum = {
  PENDING_APPROVAL: 1,
  APPROVED: 2,
  CANCELED: 3,
};

export const PreOrderStatusText = {
  [PreOrderStatusEnum.PENDING_APPROVAL]: "Em aprovação",
  [PreOrderStatusEnum.APPROVED]: "Aprovado",
  [PreOrderStatusEnum.CANCELED]: "Cancelado",
};

export const PreOrderStatusOptionList = [
  {
    value: PreOrderStatusEnum.PENDING_APPROVAL,
    label: PreOrderStatusText[PreOrderStatusEnum.PENDING_APPROVAL],
  },
  {
    value: PreOrderStatusEnum.APPROVED,
    label: PreOrderStatusText[PreOrderStatusEnum.APPROVED],
  },
  {
    value: PreOrderStatusEnum.CANCELED,
    label: PreOrderStatusText[PreOrderStatusEnum.CANCELED],
  },
];